import { create } from 'zustand'

import type { CountryInfo } from '@src/i18n/countries'
import { countries } from '@src/i18n/countries'
import type { CountryCode } from '@src/i18n/locales'
import type { Geolocation } from '@src/utils/geolocation'

interface GeolocationStore {
  geoLocation: Geolocation | null
  setGeoLocation: (location: Geolocation | null) => void
  countryInfo: CountryInfo
  setCountryInfo: (countryInfo: CountryInfo) => void
  setCountry: (country: CountryCode) => void
}

const useGeolocationStore = create<GeolocationStore>((set) => ({
  geoLocation: null,
  setGeoLocation: (geoLocation) => {
    set(() => ({ geoLocation }))
  },
  countryInfo: countries.US,
  setCountryInfo: (locality) => {
    set(() => ({ countryInfo: locality }))
  },
  setCountry: (country: CountryCode) => {
    const countryInfo = countries[country]
    set(() => ({ countryInfo: countryInfo ?? countries.US }))
  },
}))

export default useGeolocationStore
